import React, { useMemo } from "react";
import Lottie from "lottie-react";
import animationData from "../../assets/animation/animations/animation.json";

import img2 from "../../assets/animation/images/2.webp";
import img3 from "../../assets/animation/images/3.webp";
import img4 from "../../assets/animation/images/4.webp";
import img5 from "../../assets/animation/images/5.webp";
import img6 from "../../assets/animation/images/6.webp";
import img7 from "../../assets/animation/images/7.webp";
import img8 from "../../assets/animation/images/8.webp";
import img9 from "../../assets/animation/images/9.webp";
import img19 from "../../assets/animation/images/19.webp";
import img20 from "../../assets/animation/images/20.webp";
import img35 from "../../assets/animation/images/35.webp";
import img40 from "../../assets/animation/images/40.webp";
import img41 from "../../assets/animation/images/41.webp";

interface MyLottieProps {
  width?: number;
  height?: number;
  className?: string;
}

const imageMap: { [key: string]: string } = {
  "2.webp": img2,
  "3.webp": img3,
  "4.webp": img4,
  "5.webp": img5,
  "6.webp": img6,
  "7.webp": img7,
  "8.webp": img8,
  "9.webp": img9,
  "19.webp": img19,
  "20.webp": img20,
  "35.webp": img35,
  "40.webp": img40,
  "41.webp": img41,
};

const MyLottie: React.FC<MyLottieProps> = ({ 
  width = 70, 
  height = 70,
  className = ""
}) => {
  const modifiedAnimationData = useMemo(() => {
    if (!animationData || !animationData.assets) {
      return animationData;
    }

    const modified = JSON.parse(JSON.stringify(animationData));

    if (modified.assets) {
      modified.assets.forEach((asset: any) => {
        if (asset.p && imageMap[asset.p]) {
          asset.u = "";
          asset.p = imageMap[asset.p];
        }
      });
    }

    return modified;
  }, []);

  return (
    <div className={className} style={{ width, height, position: 'absolute', right: '5px', bottom: '5px' }}>
      <Lottie
        animationData={modifiedAnimationData}
        loop={true}
        autoplay={true}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
};

export default MyLottie;
